define('modules/base/models/utils.model',[
    'underscore',
    'backbone',
    'modules/base/models/utils/validation',
    'modules/base/models/utils/identity',
    'moment'
], function(_, Backbone, Validation, identityValModel, moment){
    var UtilsModel = Backbone.Model.extend({
        validation: new Validation(),
        identity : new identityValModel(),
        htmlEncode:function (value){
            return $('<div/>').text(value).html();
        },
        htmlDecode:function(value){
            return $('<div/>').html(value).text();
        },
        initialize: function() {
            this.debugName = "utilities";
            this.browserName = this.getBrowserName(this.dataBrowser) || "Other";
            this.browserVersion = this.getBrowserVersion(navigator.userAgent) || this.getBrowserName(navigator.appVersion) || "Unknown";
        },
        trackEvent:function(obj,cat) {
            try {
                if (typeof _gaq != 'undefined') {
                    _gaq.push(['_trackEvent', obj, cat, new Date().toUTCString()]);
                }
            } catch(e) {
                this.output(this.debugName,'error in ga ' + e);
            }
        },
        numberWithCommas:function(x) {
            if(x == undefined){
                x = 0;
            }
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        getQueryStringParameter: function(qry,name){
            if(typeof qry !== undefined && qry !== ""){
                var keyValueArray = qry.split("&");
                for ( var i = 0; i < keyValueArray.length; i++) {
                    if(keyValueArray[i].indexOf(name)>-1){
                        return keyValueArray[i].split("=")[1];
                    }
                }
            }
            return null;
        },
        stripHtml: function(val) {
            var re = /(<([^>]+)>)/ig;
            return val.replace(re, "");
        },
        highlightKeyword:function(s,filter) {
            var re = new RegExp(""+ filter + "","gi");
            var match = re.exec(s);
            s = s.replace(/&#39;/g, "'");
            if (match != null) {
                return s.replace(re,'<b>' + match[0] + '</b>');
            } else {
                return s;
            }
        },
        stripKeyWordsHighlight:function(s) {
            return s.replace(/\<b>/gi,'').replace(/<\/b>/g,'');
        },
        makeTitleCase: function(str) {
            if (typeof str == 'undefined') return;
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        },
        makeDateFromString:function(s) {
            if (s.length == 4) {
                return new Date('01/01/' + s);
            } else {
                return new Date(s);
            }

        },
        makeUrl: function(base) {
            var baseSub = "login.relpro.com";
            if(window.utils.readCookie("specifiedHost") != null && window.utils.readCookie("specifiedHost") != "undefined"){
                baseSub = window.utils.readCookie("specifiedHost");
            }
            if(window.location.href.indexOf("http://") > -1){
                return 'http://' + baseSub + "/" + base;
            } else {
                return 'https://' + baseSub + "/" + base;
            }
        },
        makeElipsis: function(val,len) {
            if (val.length > len) {
                val = val.substring(0,len-3) + '...';
                return val;
            } else {
                return val;
            }
        },
        getItemAsCommaList:function(item, itemNumber, totalItems){
            if(itemNumber ==  (totalItems - 1)){
                return item;
            } else if(itemNumber ==  (totalItems - 2)){
                return item+ " and ";
            } else {
                return item+ ", ";
            }
        },
        removeDuplicatesInArray: function(input) {
            var uniqueValues = [];
            if (input.length > 0) {
                _.each(input, function(el){
                    if($.inArray(el, uniqueValues) === -1 && el.length > 0) uniqueValues.push(el);
                });
            }
            return uniqueValues;
        },
        // Check for valid credit card type/number
        dataBrowser:[
            { string: navigator.userAgent, subString: "Chrome",  identity: "Chrome" },
            { string: navigator.userAgent, subString: "MSIE",    identity: "Explorer" },
            { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
            { string: navigator.userAgent, subString: "Safari",  identity: "Safari" },
            { string: navigator.userAgent, subString: "Opera",   identity: "Opera" },
            { string: navigator.userAgent, subString: "WOW64",   identity: "Explorer" }
        ],
        getBrowserName: function (data){
            try {
                for (var i=0 ; i < data.length ; i++)
                {
                    var dataString = data[i].string;
                    this.versionSearchString = data[i].subString;

                    if (dataString.indexOf(data[i].subString) != -1)
                    {
                        return data[i].identity;
                    }
                }
            } catch(ex) {
                return "Other";
            }

        },
        getBrowserVersion: function (dataString) {
            var index = dataString.indexOf(this.versionSearchString);
            if (index == -1) return;
            return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
        },
        getBrowserInfo:function(){
            var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|crios|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if(/trident/i.test(M[1])){
                tem=/\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE '+(tem[1]||'');
            }
            if(M[1]==='Chrome'){
                tem=ua.match(/\bOPR\/(\d+)/)
                if(tem!=null)   {return 'Opera '+tem[1];}
            }
            M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
            if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
            return {
                name: M[0],
                version: M[1]
            };
        },
        isChromeExt: function(){
            if (window.chrome && chrome.runtime && chrome.runtime.id) {
                return true;
            } else {
                return false
            }
        },
        CHROME_CLIENT_ID: 'EmrGLcH.RmoGLEw',
        MOBILE_CLIENT_ID_UAT: 'K57nmP8B.Tnk480',
        MOBILE_CLIENT_ID_PROD: '3T#67he.Ygf57F',
        blurForm:function() {
            if (this.isTouch()) {
                document.activeElement.blur();
                window.scrollTo(0,0);
            }
        },
        screenTop: function() {
            var doc = document.documentElement, body = document.body;
            var left = (doc && doc.scrollLeft || body && body.scrollLeft || 0);
            var top = (doc && doc.scrollTop  || body && body.scrollTop  || 0);
            return {top: top, left: left};
        },
        screenSize: function(){
            var w = 0;var h = 0;
            //IE
            if(!window.innerWidth){
                if(!(document.documentElement.clientWidth == 0)){
                    //strict mode
                    w = document.documentElement.clientWidth;h = document.documentElement.clientHeight;
                } else{
                    //quirks mode
                    w = document.body.clientWidth;h = document.body.clientHeight;
                }
            } else {
                //w3c
                w = window.innerWidth;h = window.innerHeight;
            }
            return {width:w,height:h};
        },
        screenCenter: function(){
            var hWnd = (arguments[0] != null) ? arguments[0] : {width:0,height:0};
            var _x = 0;var _y = 0;var offsetX = 0;var offsetY = 0;
            //IE
            if(!window.pageYOffset){
                //strict mode
                if(!(document.documentElement.scrollTop == 0)){offsetY = document.documentElement.scrollTop;offsetX = document.documentElement.scrollLeft;}
                //quirks mode
                else{offsetY = document.body.scrollTop;offsetX = document.body.scrollLeft;}}
            //w3c
            else    {
                offsetX = window.pageXOffset;
                offsetY = window.pageYOffset;
            }
            _x = ((this.screenSize().width-hWnd.width)/2)+offsetX;_y = ((this.screenSize().height-hWnd.height)/2)+offsetY;
            return{x:_x,y:_y};
        },
        clickPoint:function(e) {
            var x;
            var y;
            if (e.pageX || e.pageY) {
                x = e.pageX;
                y = e.pageY;
            }
            else {
                x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
                y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
            }
            return {x:x,y:y};
        },
        resetUiPosition: function() {
            window.scrollTo(0,0);
            $('.leftPanel').css('top', '0px');
        },
        removeViewCollection:function(v) {
            _.each(v,function(sv){
                this.deepCleanView(sv);
            },this);
        },
        deepCleanView:function(view) {
            if (view != null) {
                if (this.recursiveRemoveSubViews(view)) {
                    this.recursiveRemoveSubViews(view);
                } else {
                    return false;
                }
            }
        },
        recursiveRemoveSubViews: function(v) {
            if (typeof v.subviews != 'undefined') {
                _.each(v.subviews,function(sv){
                    sv.unbind();
                    sv.remove();
                    return true;
                });
            } else {
                return false;
            }
        },
        cleanModelViewFromHistory:function(model) {
            var index = 0;
            var splice = new Array();
            _.each(window.viewHistory,function(vh){
                if (typeof vh.data != 'undefined') {
                    if (typeof vh.data.data != 'undefined') {
                        if (typeof vh.data.data.source != 'undefined') {
                            if (parseInt(vh.data.data.source.refId) == model.get('id')) {
                                splice.push(index);
                            }
                        }
                    }
                }
                index++;
            },this);
            index = 0;
            if (splice.length > 0) {
                _.each(splice,function(s){
                    window.viewHistory.splice(s-index,1);
                    index++;
                },this);

            }
        },
        cleanView:function(view) {
            _.each(view.subviews,function(v){
                v.unbind();
                v.remove();
            },this);
            view.unbind();
            view.remove();
        },
        cleanSubViews:function(sv) {
            _.each(sv,function(v){
                v.unbind();
                v.remove();
            },this);
        },
        isTouch:function() {
            switch(navigator.platform.toLowerCase()) {
                case 'iphone':
                    return true;
                    break;
                case 'ipad simulator':
                    return true;
                    break;
                case 'ipad':
                    return true;
                    break;
                default:
                    return false;
            }
        },
        showDebug:function(){
            var returnVal = false;
            if(window.debug != undefined){
                returnVal = window.debug;
            }
            return returnVal;
        },
        outputObject:function(title,o) {
            if (this.showDebug() && typeof console != 'undefined') {
                console.group(title);
                console.dir(o);
                console.groupEnd();
            }
        },
        output: function(o,s) {
            if (this.showDebug() && typeof console != 'undefined') {
                console.log(new Date().toUTCString() + ': ' + o + ' - ' + s);
            }
        },
        rawOutput: function(s) {
            if (this.showDebug() && typeof console != 'undefined') {
                console.log(new Date().toUTCString() + ': ' + s);
            }
        },
        trackEvent: function(object,action,label) {
            if (typeof _gaq != 'undefined') {
                _gaq.push(['_trackEvent', object, action, label]);
            }
        },
        supportCookie: function() {
            if (typeof document.cookie == 'undefined') {
                return false;
            } else {
                return true;
            }
        },
        LOCAL_STORAGE: 'local',
        CHROME_STORAGE: 'chrome',
        COOKIE_STORAGE: 'cookie',
        localStorage: function() {
            if (
                    (window.chrome != undefined && window.chrome.storage != undefined  && window.chrome.storage != null) ||
                    (window.localStorage != undefined && window.localStorage != null)
            ){
                return true;
            } else {
                return false;
            }
        },
        getLocalStorage: function() {
            var type = null;
            if (window.chrome != undefined && window.chrome.storage != undefined && window.chrome.storage != null) {
                type = this.CHROME_STORAGE;
            } else if (window.localStorage != undefined && window.localStorage != null) {
                type = this.LOCAL_STORAGE;
            } else  if (this.supportCookie()) {
                type = this.COOKIE_STORAGE;
            }
            return type;
        },
        clearStorage:function(cb){
            if(this.getLocalStorage() == this.CHROME_STORAGE){
                return this.clearChromeStorage(cb);
            } else if(this.getLocalStorage() == this.LOCAL_STORAGE){
                return this.clearLocalStorage(cb);
            } else {
                if(this.getLocalStorage() == this.COOKIE_STORAGE){
                    this.eraseCookie("accessToken")
                }
                cb();
            }
        },
        readStorageObject:function(key){
            if(this.getLocalStorage() == this.CHROME_STORAGE){
                return this.readChromeStorageObject(key);
            } else if(this.getLocalStorage() == this.LOCAL_STORAGE){
                return this.readLocalStorageObject(key);
            } else{
                return new Promise(function(resolve,reject){
                   resolve(null)
                });
            }
        },
        readStorageField:function(key){
            if(this.getLocalStorage() == this.CHROME_STORAGE){
                return this.readChromeStorageField(key);
            } else if(this.getLocalStorage() == this.LOCAL_STORAGE){
                return this.readLocalStorageField(key);
            } else if(this.getLocalStorage() == this.COOKIE_STORAGE){
                var that = this;
                return new Promise(function(resolve,reject){
                    resolve(that.readCookie(key))
                });
            } else{
                return new Promise(function(resolve,reject){
                    resolve(null)
                });
            }
        },
        eraseStorageObject:function(key){
            if(this.getLocalStorage() == this.CHROME_STORAGE){
                return this.eraseChromeStorageObject(key);
            } else if(this.getLocalStorage() == this.LOCAL_STORAGE){
                return this.eraseLocalStorageObject(key);
            } else{
                return new Promise(function(resolve,reject){
                    resolve(null)
                });
            }
        },
        writeStorageObject:function(key, obj){
            if(this.getLocalStorage() == this.CHROME_STORAGE){
                return this.writeChromeStorageObject(key, obj);
            } else if(this.getLocalStorage() == this.LOCAL_STORAGE){
                return this.writeLocalStorageObject(key, obj);
            } else{
                return new Promise(function(resolve,reject){
                    resolve(null)
                });
            }
        },
        writeStorageField:function(key, value){
            if(this.getLocalStorage() == this.CHROME_STORAGE){
                return this.writeChromeStorageField(key, value);
            } else if(this.getLocalStorage() == this.LOCAL_STORAGE){
                return this.writeLocalStorageField(key, value);
            } else if(this.getLocalStorage() == this.COOKIE_STORAGE){
                var that = this;
                return new Promise(function(resolve,reject){
                    resolve(that.createCookie(key, value));
                });
            } else{
                return new Promise(function(resolve,reject){
                    resolve(null)
                });
            }
        },

        clearLocalStorage:function(cb){
            var that = this;
            var returnBool = false;
            return new Promise(function(resolve, reject){
                try{
                    if(that.localStorage()){
                        window.localStorage.clear();
                        returnBool = true;
                    }
                    cb();
                    resolve();
                } catch(ex){
                    reject(ex);
                }
            });
        },
        readLocalStorageObject:function(key){
            var that = this;
            return new Promise(function(resolve, reject){
                var returnObj = null;
                try{
                    var objStr = window.localStorage.getItem(key);
                    resolve(returnObj);
                } catch(ex){
                    reject(ex);
                }
            });
        },
        readLocalStorageField:function(key){
            var that = this;
            return new Promise(function(resolve, reject){
                var returnObj = null;
                try{
                    returnObj = window.localStorage.getItem(key);
                    resolve(returnObj);
                } catch(ex){
                    reject(ex);
                }
            });
        },
        eraseLocalStorageObject:function(key){
            var that = this;
            return new Promise(function(resolve, reject){
                var returnBool = false;
                try{
                    window.localStorage.removeItem(key);
                    returnBool = true;
                    resolve(returnBool);
                } catch(ex){
                    reject(ex);
                }
            });
        },
        writeLocalStorageObject:function(key, obj){
            var that = this;
            return new Promise(function(resolve, reject){
                var returnBool = false;
                try{
                    window.localStorage.setItem(key, JSON.stringify(obj));
                    returnBool = true;
                    resolve(returnBool);
                } catch(ex){
                    reject(ex);
                }
            });
        },
        writeLocalStorageField:function(key, value){
            var that = this;
            return new Promise(function(resolve, reject){
                var returnBool = false;
                try{
                    window.localStorage.setItem(key, value);
                    returnBool = true;
                    resolve(returnBool);
                } catch(ex){
                    reject(ex);
                }
            });
        },
        clearChromeStorage:function(cb){
            var returnBool = false;
            try{
                window.chrome.storage.local.clear(function(){
                    cb();
                });
                returnBool = true;
            } catch(ex){
            }
            return returnBool;
        },
        readChromeStorageObject:function(key){
            var returnObj = null;
            try{
                if(this.localStorage()){
                    return new Promise(function(resolve, reject){
                        window.chrome.storage.local.get(key, function(value){
                            if(value[key]!=undefined){
                                returnObj = JSON.parse(value[key]);
                            }
                            resolve(returnObj);
                        });
                    })
                }
            } catch(ex){
            }
            return returnObj;
        },
        readChromeStorageField:function(key){
            var returnObj = null;
            try{
                if(this.localStorage()){
                    return new Promise(function(resolve, reject){
                        window.chrome.storage.local.get(key, function(value){
                            if(value[key]!=undefined){
                                returnObj = value[key];
                            }
                            resolve(returnObj);
                        });
                    })

                }
            } catch(ex){
            }
            return returnObj;
        },
        eraseChromeStorageObject:function(key){
            var returnBool = false;
            try{
                if(this.localStorage()){
                    //window.chrome.storage.local.set({key: undefined});
                    //returnBool = true;
                }
            } catch(ex){
            }
            return returnBool;
        },
        writeChromeStorageObject:function(key, obj){
            var returnBool = false;
            var data = {};
            data[key] = JSON.stringify(obj);
            try{
                if(this.localStorage()){
                    window.chrome.storage.local.set(data);
                    returnBool = true;
                }
            } catch(ex){

            }
            return returnBool;
        },
        writeChromeStorageField:function(key, value){
            var returnBool = false;
            var data = {};
            data[key] = value;
            try{
                if(this.localStorage()){
                    window.chrome.storage.local.set(data);
                    returnBool = true;
                }
            } catch(ex){
            }
            return returnBool;
        },
        sessionStorage: function () {
            if (window.sessionStorage == undefined || !window.sessionStorage) {
                return false;
            } else {
                return true;
            }
        },
        clearSessionStorage: function () {
            if (this.sessionStorage()) {
                window.sessionStorage.removeItem("searchQuery");
                window.sessionStorage.removeItem("fname");
                window.sessionStorage.removeItem("lname");
                window.sessionStorage.removeItem("org");
                window.sessionStorage.removeItem("title");
                window.sessionStorage.removeItem("state");
                window.sessionStorage.removeItem("showTab");
            }
        },
        readSessionStorageObject: function (key) {
            var returnObj = null;
            try {
                if (this.sessionStorage()) {
                    var objStr = window.sessionStorage.getItem(key);
                    returnObj = JSON.parse(objStr);
                }
            } catch (ex) {
            }
            return returnObj;
        },
        readSessionStorageField: function (key) {
            var returnObj = null;
            try {
                if (this.sessionStorage()) {
                    returnObj = window.sessionStorage.getItem(key);
                }
            } catch (ex) {
            }
            return returnObj;
        },
        eraseSessionStorageObject: function (key) {
            try {
                if (this.sessionStorage()) {
                    window.sessionStorage.removeItem(key);
                }
            } catch (ex) {
            }
        },
        writeSessionStorageObject: function (key, obj) {
            try {
                if (this.sessionStorage()) {
                    window.sessionStorage.setItem(key, JSON.stringify(obj));
                }
            } catch (ex) {
            }
        },
        writeSessionStorageField: function (key, field) {
            try {
                window.sessionStorage.setItem(key, field);
            } catch (ex) {
            }
        },

        createCookie: function(name,value,days) {
            if (typeof document.cookie == 'undefined') {
                return false
            } else {
                var now = new Date();
                var time = now.getTime();
                var expireTime = time + 1000*60*60*10; //10 Hours
                now.setTime(expireTime);
                document.cookie = name+"="+value+"; expires="+now.toUTCString()+"; path=/";
                return true;
            }
        },
        readCookie: function(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        },
        eraseCookie: function(name) {
            this.createCookie(name,"",-1);
        },
        /**ui methods**/
        getInternalLists:function(){
            return this.getListBySource(1);
        },
        getConnectivityLists:function(){
            return this.getListBySource(2020);
        },
        appendByComma:function(appended, appendee){
            if(appendee == undefined){
                return appended;
            }
            else {
                if(appended != ""){
                    return appended + ", " +  appendee;
                } else {
                    return appendee;
                }
            }
        },
        appendByCommaAndAnd:function(list){
            var returnVal = "";
            for(var i = 0; i < list.length; i++){
                if(i == (list.length-1)){
                    returnVal += list[i];
                } else if(i == (list.length-2)){
                    returnVal += list[i] + " and ";
                } else {
                    returnVal += list[i] + ", ";
                }
            }
            return returnVal;
        },
        getListBySource:function(source){
            var lists = new Array();
            if(window.user.get('lists')!= undefined){
                _.each(window.user.get('lists'), function(list){
                    if(list.source.sourceId == source){
                        lists.push(list);
                    }
                }, this);
            }
            return lists;
        },
        makeElipsis: function(val,len) {
            if (val.length > len) {
                val = val.substring(0,len-3) + '...';
                return val;
            } else {
                return val;
            }
        },
        cleanLink: function(mlink){
            var link = mlink;
            if(link.substring(0,7) == 'http://'){
                link = link.substring(7);
            }
            if(link.substring(0,8) == 'https://'){
                link = link.substring(8);
            }
            var index = link.indexOf('/');
            if(index > -1){
                link = link.substr(0, index);
            }
            return link;
        },
        formatDate:function(date){
            var returnVal = "";
            if(date != undefined && date != ""){
                var date = new moment(date, 'MM/DD/YYYY');
                returnVal = date.format('MMM Do, YYYY');
            }
            return returnVal;
        },
        gaPageTrack:function(slash){
            if(typeof ga !== "undefined"){
                ga('set', 'page', slash);
                ga('send', 'pageview');
            }
        },
        raygunTrack:function(slash){
            try{
                Raygun.trackEvent('pageView', { path: '/' + slash });
            } catch(ex){
                
            }
        },
        levenshtein: function(a, b){
            if(!a || !b) return (a || b).length;
            var m = [];
            for(var i = 0; i <= b.length; i++){
                m[i] = [i];
                if(i === 0) continue;
                for(var j = 0; j <= a.length; j++){
                    m[0][j] = j;
                    if(j === 0) continue;
                    m[i][j] = b.charAt(i - 1) == a.charAt(j - 1) ? m[i - 1][j - 1] : Math.min(
                            m[i-1][j-1] + 1,
                            m[i][j-1] + 1,
                            m[i-1][j] + 1
                        );
                }
            }
            return m[b.length][a.length];
        },
        buildLinkedInLink:function(firstName, lastName, company){
            var query = "";
            if(company != ""){
                query += "keywords=" + encodeURIComponent(company)
            }
            if(firstName != ""){
                if(query != ""){
                    query += "&"
                }
                query+="firstName="+ encodeURIComponent(firstName);
            }
            if(lastName != ""){
                if(query != ""){
                    query += "&"
                }
                query+="lastName="+ encodeURIComponent(lastName);
            }
            if(query != "") {
                query = "https://www.linkedin.com/search/results/people/?" + query +"&origin=FACETED_SEARCH";
            }
            return query;
        },
        buildLinkedInLinkMultComp:function(firstName, lastName, companies){
            var query = "";
            if(companies.length != 0){
                query += "keywords="
                var companiesQ = ""
                for(var i = 0; i < companies.length; i++){
                    if(i != 0){
                        companiesQ += " OR "
                    }
                    companiesQ+= '"' +  companies[i] + '"'
                }
                query += encodeURIComponent(companiesQ);
            }
            if(firstName != ""){
                if(query != ""){
                    query += "&"
                }
                query+="firstName="+ encodeURIComponent(firstName);
            }
            if(lastName != ""){
                if(query != ""){
                    query += "&"
                }
                query+="lastName="+ encodeURIComponent(lastName);
            }
            if(query != "") {
                query = "https://www.linkedin.com/search/results/people/?" + query +"&origin=FACETED_SEARCH";
            }
            return query;
        }
    });
    return UtilsModel;
});

